import { render } from "./VehicleDetail.vue?vue&type=template&id=bbca3c0a&scoped=true"
import script from "./VehicleDetail.vue?vue&type=script&lang=js"
export * from "./VehicleDetail.vue?vue&type=script&lang=js"

import "./VehicleDetail.vue?vue&type=style&index=0&id=bbca3c0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbca3c0a"]])

export default __exports__